const initialState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
}
const resetState = {
  workOrderType: 'all',
  workOrderStatus: 'all',
  startDate: '',
  endDate: '',
  searchData: {},
  searchOption: '',
  searchText: '',
  pageNumber: 1,
  totalSize: 0,
  isPushedSearchButton: false,
};

const productionStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETPRODUCTIONSTATUSWORKORDERTYPE':
      return {
        ...state,
        workOrderType: action.payload,
      };
    case 'SETPRODUCTIONSTATUSWORKORDERSTATUS':
      return {
        ...state,
        workOrderStatus: action.payload,
      };
    case 'SETPRODUCTIONSTATUSSTARTDATE':
      return {
        ...state,
        startDate: action.payload,
      };
    case 'SETPRODUCTIONSTATUSENDDATE':
      return {
        ...state,
        endDate: action.payload,
      };
    case 'SETPRODUCTIONSTATUSSEARCHDATA':
      return {
        ...state,
        searchData: action.payload,
      };
    case 'SETPRODUCTIONSTATUSSEARCHOPTION':
      return {
        ...state,
        searchOption: action.payload,
      };
    case 'SETPRODUCTIONSTATUSSEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETPRODUCTIONSTATUSPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETPRODUCTIONSTATUSTOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETPRODUCTIONSTATUSISPUSHEDSEARCHBUTTON':
      return {
        ...state,
        isPushedSearchButton: action.payload,
      };
    case 'SETPRODUCTIONSTATUSRESET':
      return {
        ...state,
        ...resetState,
      };
    default:
      return state;
  };
};

export default productionStatusReducer;